export default defineNuxtRouteMiddleware((to) => {
	const cleanPath = dropUnderscoreRouteParts(to.path);

	if (cleanPath !== to.path) {
		return navigateTo({
			path: cleanPath,
			query: to.query,
		});
	}
});
